import React from "react";
import { Link } from "react-router-dom";
import { Reveal, Eyebrow, PageHeader } from "../components/common";
import { CONTACT_INFO } from "../mock";

const SECTIONS = [
  {
    title: "1. Acceptance of These Terms",
    body:
      "By accessing or using this website, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our website.",
  },
  {
    title: "2. Ownership of Content",
    body:
      "All content on this website — including text, photographs, graphics, and the page design and layout — is owned by Rajiv Syndicate Group and protected by copyright. This is what the “All rights reserved” notice in our footer refers to: Rajiv Syndicate Group retains every exclusive right below, and does not grant them to visitors by default.",
  },
];

const RIGHTS = [
  { label: "Reproduction", body: "The right to copy or duplicate the content, in whole or in part, in any form." },
  { label: "Distribution", body: "The right to control who else receives copies of the content — no republishing our text or photos on another site, brochure, or listing." },
  { label: "Public display", body: "The right to control where the content is shown publicly, including on other websites, social media, apps, or print material." },
  { label: "Adaptation", body: "The right to control modified or derivative versions of the content — translating, editing, or otherwise creating a version “based on” it." },
  { label: "Authorisation", body: "Only Rajiv Syndicate Group may grant someone else permission to do any of the above, such as licensing a photo to a partner." },
];

export default function TermsAndConditions() {
  return (
    <>
      <PageHeader
        crumb="Terms and Conditions"
        title="Terms and Conditions"
        intro="These Terms and Conditions govern your use of the Rajiv Syndicate Group website and set out the rights we hold over its content. Please read them alongside our Privacy Policy, which covers how we handle your personal information."
      />

      <section className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
        <Reveal><Eyebrow>Last updated · 2026</Eyebrow></Reveal>

        <Reveal delay={0}>
          <div className="py-9 border-b border-[var(--rs-border)]">
            <h2 className="font-head font-bold text-2xl">{SECTIONS[0].title}</h2>
            <p className="text-[var(--rs-muted)] mt-3 leading-relaxed">{SECTIONS[0].body}</p>
          </div>
        </Reveal>

        <Reveal delay={40}>
          <div className="py-9 border-b border-[var(--rs-border)]">
            <h2 className="font-head font-bold text-2xl">{SECTIONS[1].title}</h2>
            <p className="text-[var(--rs-muted)] mt-3 leading-relaxed">{SECTIONS[1].body}</p>
            <ul className="mt-5 space-y-4">
              {RIGHTS.map((p) => (
                <li key={p.label} className="flex gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--rs-blue)] shrink-0 mt-2.5" />
                  <p className="text-[var(--rs-muted)] leading-relaxed">
                    <span className="text-[var(--rs-ink)] font-semibold">{p.label}: </span>
                    {p.body}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="py-9 border-b border-[var(--rs-border)]">
            <h2 className="font-head font-bold text-2xl">3. Trademarks</h2>
            <p className="text-[var(--rs-muted)] mt-3 leading-relaxed">
              The Rajiv Syndicate name and logo are our business identifiers and may not be used to imply endorsement or affiliation
              without permission — this is a separate protection from the copyright covered above.
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="py-9 border-b border-[var(--rs-border)]">
            <h2 className="font-head font-bold text-2xl">4. Changes to These Terms</h2>
            <p className="text-[var(--rs-muted)] mt-3 leading-relaxed">
              Rajiv Syndicate Group may update these Terms and Conditions periodically. We encourage you to review this page
              regularly for the latest version.
            </p>
          </div>
        </Reveal>

        <Reveal delay={160}>
          <div className="py-9">
            <h2 className="font-head font-bold text-2xl">5. Contact Us</h2>
            <p className="text-[var(--rs-muted)] mt-3 leading-relaxed">
              If you have any questions about these Terms and Conditions, please contact us at:
            </p>
            <div className="mt-6 bg-[var(--rs-bg)] border border-[var(--rs-border)] rounded-2xl p-7">
              <p className="font-head font-bold text-lg">Rajiv Syndicate Group</p>
              <p className="text-[var(--rs-muted)] mt-1">{CONTACT_INFO.address.join(" ")}</p>
              <p className="text-[var(--rs-muted)] mt-3">
                Email:{" "}
                <a href={`mailto:${CONTACT_INFO.general}`} className="text-[var(--rs-blue)] font-medium hover:underline">
                  {CONTACT_INFO.general}
                </a>
              </p>
              <p className="text-[var(--rs-muted)] mt-1">
                Phone:{" "}
                <a href="tel:+919215926601" className="text-[var(--rs-blue)] font-medium hover:underline">
                  {CONTACT_INFO.accounts[0]}
                </a>
              </p>
            </div>
            <p className="text-[var(--rs-muted)] mt-8">
              See also our{" "}
              <Link to="/privacy-policy" className="text-[var(--rs-blue)] font-medium hover:underline">
                Privacy Policy
              </Link>.
            </p>
          </div>
        </Reveal>
      </section>
    </>
  );
}
